let _isProd: boolean | undefined = undefined;

export function isProd() {
  if (_isProd !== undefined) {
    return _isProd;
  }

  const metaTags = document.querySelectorAll<HTMLMetaElement>('meta');

  for (const metaTag of metaTags) {
    if (metaTag.name === 'env') {
      _isProd = metaTag.content === 'production';
    }
  }

  return _isProd;
}
